import { useAuthentication } from '@mcity/siauliai-core/src/components/providers'

export default function UserName({ children }) {
  const { profile } = useAuthentication()
  return children({ ...profile })
}
